import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Layout from "../pages/Layout";
import "../css/UserDetail.css";
import { defaultAxiosInstance } from "../api/defaultInstance";
import MembershipRefundModal from "../modules/membership/components/MembershipRefundModal";
import { useUser } from "../context/UserContext";

function UserDetail() {
  useEffect(() => {
    console.log("PageB 렌더링됨!");
  });

  // eslint-disable-next-line no-unused-vars
  const [isFourByFour, setIsFourByFour] = useState(false); // 배열 전환 상태
  const [places, setPlaces] = useState([]); // 등록된 플레이스 데이터
  const [selectedPlace, setSelectedPlace] = useState(""); // 드롭다운에서 선택한 플레이스
  const [isRowExpanded, setIsRowExpanded] = useState(false); // 행 확장 상태
  const { userId } = useParams(); // useParams 훅을 사용하여 userId 가져오기
  const { userInfo } = useUser();

  const [formData, setFormData] = useState({
    userId: 0,
    email: "",
    phoneNumber: "",
    name: "",
    birthDate: "",
    regDate: "",
    role: "",
    subscriptionInfo: null,
    referralCode: "",
    refundInfo: null,
  });

  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);

  const ADMIN_EMAILS = [
    "amplify15813@gmail.com",
    "codudgh0810@naver.com",
    "hyebin3_3@naver.com",
    "wpdls0925@daum.net",
    "jiwonnn0803@gmail.com",
  ];

  const isAdminEmail = ADMIN_EMAILS?.includes(userInfo.email);

  const fetchUserData = async () => {
    try {
      const userResponse = await defaultAxiosInstance.get(`/user/id`, {
        params: { userId },
      });
      setFormData(userResponse.data);
      const placesResponse = await defaultAxiosInstance.get(`/place/userId`, {
        params: { userId },
      });
      setPlaces(placesResponse.data);
    } catch (error) {
      console.error("데이터 로드 중 오류:", error);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchUserData();
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // eslint-disable-next-line no-unused-vars
  const handleToggleLayout = () => {
    setIsFourByFour((prevState) => !prevState);
  };

  const handleSave = async () => {
    try {
      const userInfo = {
        userId: formData.userId,
        name: formData.name,
        phoneNumber: formData.phoneNumber,
        role: formData.role,
        birthDate: formData.birthDate,
        subscriptionType: formData.subscriptionInfo
          ? formData.subscriptionInfo.type
          : null,
        subEndDate: formData.subscriptionInfo
          ? formData.subscriptionInfo.endDate
          : null,
      };

      console.log(userInfo);

      const response = await defaultAxiosInstance.put("/admin/user", userInfo);
      console.log(response);
      alert("수정이 완료되었습니다.");
      console.log("수정된 데이터:", response.data);
    } catch (error) {
      console.log(error.response.data);
      if (error.response.data.type === "/errors/phone_number_exist") {
        alert(error.response.data.detail);
      } else {
        alert("수정 중 오류가 발생했습니다. 다시 시도해주세요.");
      }
      console.error("회원 정보 수정 중 오류 발생:", error);
    }
  };

  const getSubscriptionLabel = (type) => {
    if (type === "basic" || type === "standard" || type === "premium")
      return "월간 구독";
    if (type === "free") return "구독 없음";
    if (type === "owner") return "관리자";
    return type || "-";
  };

  const getPaymentPlatformLabel = (platform) => {
    if (platform === "NICEPAY") return "나이스페이";
    if (platform === "IN_APP") return "인앱 결제";
    if (platform == null) return "-";
    return platform;
  };

  // 키워드 문자열 생성 함수
  const getKeywordsString = (keywordRankArray) => {
    return keywordRankArray
      .map((keywordObj) => `#${keywordObj.keyword}`)
      .join(", ");
  };

  // 드롭다운 선택 핸들러
  const handlePlaceSelect = (e) => {
    setSelectedPlace(e.target.value);
  };

  // 필터링된 플레이스 데이터
  const filteredPlaces = selectedPlace
    ? places.filter((place) => place.placeInfo.name === selectedPlace)
    : [];

  // eslint-disable-next-line no-unused-vars
  const toggleRow = () => {
    setIsRowExpanded((prevState) => !prevState);
  };

  return (
    <Layout>
      <div className="user-detail-container">
        {/* 타이틀 */}
        <h2 className="title">회원정보 관리</h2>

        {/* 드롭다운과 타이틀 컨테이너 */}
        <div className="dropdown-title-container">
          <h4 className="sub-title">등록한 플레이스</h4>
          {/* 드롭다운 */}
          <div className="dropdown-container">
            <select
              className="form-select dropdown"
              value={selectedPlace}
              onChange={handlePlaceSelect}
            >
              <option>[등록한 플레이스]</option>
              {places.map((place, index) => (
                <option key={index} value={place.placeInfo.name}>
                  {place.placeInfo.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* 썸네일/플레이스명/카테고리 테이블 */}
        <table className="table table-bordered mb-4 place">
          <thead>
            <tr>
              <th>썸네일</th>
              <th>플레이스 명</th>
              <th>카테고리</th>
              <th>#등록한 키워드</th>
              <th className="text-center"></th>
            </tr>
          </thead>
          <tbody>
            {filteredPlaces.map((place, index) => (
              <React.Fragment key={index}>
                <tr onClick={() => setIsRowExpanded((prev) => !prev)}>
                  <td>
                    <img
                      src={
                        place.placeInfo.imageUrl ||
                        "https://via.placeholder.com/50"
                      }
                      alt="Thumbnail"
                      className="img-thumbnail"
                      style={{ width: "100px" }} // 썸네일 크기 조정
                    />
                  </td>
                  <td>{place.placeInfo.name}</td>
                  <td>{place.placeInfo.category}</td>
                  <td className="text-truncate" style={{ maxWidth: "150px" }}>
                    {getKeywordsString(place.keywordRankArray)}
                  </td>
                  <td className="text-center">{isRowExpanded ? "▲" : "▼"}</td>
                </tr>
                {isRowExpanded && (
                  <tr>
                    <td colSpan="5">
                      <div className="expanded-content">
                        {place.keywordRankArray.map((keywordObj, i) => (
                          <span key={i} className="keyword">
                            #{keywordObj.keyword}
                          </span>
                        ))}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>

        {/* 레이아웃 전환 버튼 */}
        <div className="dropdown-title-container layout-change-button">
          <h4 className="sub-title">회원 정보</h4>
          {/*}
          <div className="toggle-layout">
            <button
                className="btn btn-outline-primary"
                onClick={handleToggleLayout}
            >
                레이아웃 전환
            </button>
          </div>
          */}
        </div>

        <div className="info-table four-by-four">
          <div className="info-row2">
            <div className="info-label">이름</div>
            <div className="info-value">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-control"
              />
            </div>
            <div className="info-label">역할</div>
            <div className="info-value">
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                className="form-select"
              >
                <option value="lecturer">강사</option>
                <option value="user">일반사용자</option>
              </select>
            </div>
            <div className="info-label">추천인 코드</div>
            <div className="info-value">{formData.referralCode || "-"}</div>
          </div>
          <div className="info-row2">
            <div className="info-label">이메일(가입 ID)</div>
            <div className="info-value">{formData.email}</div>
            <div className="info-label">가입일</div>
            <div className="info-value">{formData.regDate}</div>
          </div>
          <div className="info-row2">
            <div className="info-label">연락처</div>
            <div className="info-value">
              <input
                type="text"
                name="phoneNumber"
                disabled
                value={formData.phoneNumber}
                onChange={handleChange}
                className="form-control"
              />
            </div>
          </div>
          <div className="info-row2">
            <div className="info-label">구독 종류 / 결제 플랫폼</div>
            <div
              className="info-value"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>
                {getSubscriptionLabel(formData.subscriptionInfo?.type)} /{" "}
                {getPaymentPlatformLabel(formData.refundInfo?.paymentPlatform)}
              </span>
              {isAdminEmail && (
                <button
                  className="btn btn-danger btn-sm"
                  disabled={formData.refundInfo?.paymentPlatform !== "NICEPAY"}
                  onClick={() => setIsRefundModalOpen(true)}
                >
                  환불 요청
                </button>
              )}
            </div>
          </div>
          <div className="info-row2">
            <div className="info-label">멤버십 종류</div>
            <div className="info-value">
              <select
                name="subscriptionType"
                value={
                  formData.subscriptionInfo
                    ? formData.subscriptionInfo.type
                    : "free"
                }
                onChange={(e) => {
                  const { value } = e.target;
                  setFormData({
                    ...formData,
                    subscriptionInfo: {
                      ...formData.subscriptionInfo,
                      type: value, // subscriptionInfo 객체 내 type 필드 업데이트
                      endDate: formData.subscriptionInfo
                        ? formData.subscriptionInfo.endDate
                        : "2040-01-01",
                    },
                  });
                }}
                className="form-select"
              >
                <option value="free">Free</option>
                <option value="basic">Basic</option>
                <option value="standard">Standard</option>
                <option value="premium">Premium</option>
                <option value="owner">Owner</option>
              </select>
            </div>
          </div>
          {/* 멤버십 종료일 */}
          <div
            className="info-row2"
            onClick={() => document.getElementById("subEndDate").focus()}
          >
            <div className="info-label">멤버십 종료일</div>
            <div className="info-value">
              <input
                type="date"
                id="subEndDate" // ID를 추가
                name="subEndDate"
                value={
                  formData.subscriptionInfo
                    ? formData.subscriptionInfo.endDate
                    : null
                }
                onChange={(e) => {
                  const { value } = e.target;
                  setFormData({
                    ...formData,
                    subscriptionInfo: {
                      ...formData.subscriptionInfo,
                      type: formData.subscriptionInfo
                        ? formData.subscriptionInfo.type
                        : "free", // subscriptionInfo 객체 내 type 필드 업데이트
                      endDate: value,
                    },
                  });
                }}
                className="form-control"
              />
            </div>
          </div>
        </div>

        {/* 회원 정보 테이블 */}
        {/*{isFourByFour ? (
          // 4행 4열 레이아웃
          <div className="info-table four-by-four">
            <div className="info-row2">
              <div className="info-label">이름</div>
              <div className="info-value">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="info-label">생년월일</div>
              <div className="info-value">{formData.birthDate}</div>
            </div>
            <div className="info-row2">
              <div className="info-label">이메일(가입 ID)</div>
              <div className="info-value">{formData.email}</div>
              <div className="info-label">가입일</div>
              <div className="info-value">{formData.regDate}</div>
            </div>
            <div className="info-row2">
              <div className="info-label">연락처</div>
              <div className="info-value">
                <input
                  type="text"
                  name="contact"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
                <div className="info-label">구독 종류</div>
                <div className="info-value">{"월간 구독"}</div>
            </div>
            <div className="info-row2">
              <div className="info-label">멤버십 종류</div>
              <div className="info-value">
                    <select
                        name="subscriptionType"
                        value={formData.subscriptionInfo ? formData.subscriptionInfo.type : 'free'}
                        onChange={handleChange}
                        className="form-select"
                    >
                        <option value="free">Free</option>
                        <option value="basic">Basic</option>
                        <option value="standard">Standard</option>
                        <option value="premium">Premium</option>
                    </select>
                </div>
            </div>
          </div>
        ) : (
          // 2행 4열 레이아웃
          <div className="info-table two-by-four">
            <div className="info-row2">
              <div className="info-label">이름</div>
              <div className="info-value">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="info-label">생년월일</div>
              <div className="info-value">{formData.birthDate}</div>
              <div className="info-label">이메일(가입 ID)</div>
              <div className="info-value">{formData.email}</div>
              <div className="info-label">가입일</div>
              <div className="info-value">{formData.regDate}</div>
            </div>
            <div className="info-row2">
              <div className="info-label">연락처</div>
              <div className="info-value">
                <input
                  type="text"
                  name="contact"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
              <div className="info-label">구독 종류</div>
              <div className="info-value">{"월간 구독"}</div>
                <div className="info-label">멤버십 종류</div>
                <div className="info-value">
                    <select
                        name="subscriptionType"
                        value={formData.subscriptionInfo ? formData.subscriptionInfo.type : 'free'}
                        onChange={handleChange}
                        className="form-select"
                    >
                        <option value="free">Free</option>
                        <option value="basic">Basic</option>
                        <option value="standard">Standard</option>
                        <option value="premium">Premium</option>
                    </select>
                </div>
            </div>
          </div>
        )}
          */}

        {/* 저장/취소 버튼 */}
        <div className="button-container">
          <button className="btn btn-primary" onClick={handleSave}>
            회원 정보 수정
          </button>
        </div>
      </div>
      <MembershipRefundModal
        isOpen={isRefundModalOpen}
        userData={{
          userId: formData.userId,
          name: formData.name,
          subscriptionInfo: formData.subscriptionInfo || {},
          refundInfo: formData.refundInfo || {},
        }}
        onClose={() => setIsRefundModalOpen(false)}
        onSuccess={() => {
          setIsRefundModalOpen(false);
          fetchUserData();
        }}
      />
    </Layout>
  );
}

export default UserDetail;
